import type { FC } from 'react';
import { memo } from 'react';
import clsx from 'clsx';

import { useSizeStore } from 'store/size';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import Controls from './Controls';
import Leave from './Controls/Leave';
import styles from './styles.module.scss';

const Bottom: FC = () => {
    const { isDesktop } = useDeviceWidth();
    const { isFull } = useSizeStore();
    const isGridLayout = isDesktop && !isFull;

    return (
        <div className={clsx(styles.wrapper, { [styles.wrapperIsFull]: isFull })}>
            {isGridLayout && <div />}
            <Controls />
            {isGridLayout && <Leave />}
        </div>
    );
};

export default memo(Bottom);
